export const pieChartLoadingData = [
	{ item: 'one', count: 60 },
	{ item: 'two', count: 40 },
]
